var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .092h382.908V383H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 108.908)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.615 382.743C76.19 377.309-5.175 287.1.257 181.706 5.691 76.28 95.899-5.085 201.325.349 306.72 5.781 388.085 95.99 382.651 201.415c-5.432 105.395-95.64 186.761-201.036 181.328",
    fill: "#066",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.072 317.465c2.673-.523 61.125-43.81 61.125-43.81l-15.571-82.863-76.851-32.36-68.98 51.344 13.901 76.78 86.376 30.91z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.83 168.787s66.717 82.552 67.252 84.766c.536 2.213-1.872 36.338-1.872 36.338l-33.904 25.37-50.11-41.606-15.57-82.863 34.205-22.005z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.057 414.61l-28.96 22.979-28.254-16.595c-.019-.012-.019-.022-.039-.032-19.809-24.422-33.709-53.727-39.614-85.633v-.01l3.338-18.133 27.076-24.868 49.286 44.676 17.167 77.616z",
    fill: "#14C0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.83 168.782l-34.21 22.008-76.845-32.358-9.57-36.211 42.439-8.967a189.868 189.868 0 0163.926 26.586s.01 0 .01.01l14.25 28.932zM339.072 317.465l12.582 76.712 67.627-3.128 31.024-75.788-50.108-41.607zM191.89 336.998l60.806-50.441-13.902-76.781-70.367 4.972-25.825 77.569zM195.616 140.364l-24.281 30.881-16.375 4.924.01-.03a192.893 192.893 0 0140.636-35.775h.01zM297.618 480.025l-32.327 8.628a189.615 189.615 0 01-58.932-21.502l-.01-.011-26.252-29.551 28.96-22.979 77.694 32.442 10.867 32.973z",
    fill: "#066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.356 429.948A194.29 194.29 0 01421.088 449l9.867-15.023 10.401-4.03z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.528 317.186l-2.52 22.29a189.827 189.827 0 01-3.96-34.87l6.48 12.58z",
    fill: "#066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.955 433.977L421.1 448.98l-.011.01v.01c-24.99 20.32-55.115 34.428-87.911 40.108h-.01l-35.55-9.083-10.867-32.973 64.908-52.879 67.62-3.124 11.676 42.928z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.65 310.328c-2.385 46.269-21.113 87.92-50.294 119.62l-10.4 4.029-11.677-42.927 31.021-75.784 33.913-25.378 7.64 14.943v.01a195.961 195.961 0 01-.203 5.487M191.89 336.998l60.806-50.441 86.376 30.909 12.582 76.712-64.904 52.875-77.693-32.443zM333.168 489.107c-13.771 2.395-28.017 3.292-42.548 2.543a190.725 190.725 0 01-25.33-2.997l32.328-8.628 35.55 9.082z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.335 171.246l-2.903 43.498-25.827 77.574-27.077 24.868-6.48-12.58a189.74 189.74 0 01.21-13.987c2.257-43.792 19.139-83.435 45.67-114.431l.032-.02 16.375-4.922z",
    fill: "#14C0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.775 158.432l-68.984 51.347-70.36 4.965 2.904-43.498 24.281-30.881.011-.01c19.463-12.785 41.342-22.101 64.711-27.115h.01l37.858 8.982 9.57 36.21z",
    fill: "#14C0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.644 113.254l-42.438 8.967-37.858-8.98.011-.01a191.358 191.358 0 0149.971-3.973 191.546 191.546 0 0130.314 3.996",
    fill: "#14C0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.232 254.205l-67.402-85.423-14.25-28.931c.01 0 .01 0 .02.01 40.166 26.153 69.77 66.88 81.617 114.233 0 .01 0 .01.01.02l.005.09z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14C0C4",
    d: "M252.696 286.556l86.376 30.91-130.015 97.144 74.025-88.787-54.309-19.422z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.457 467.263c-20.694-11.863-38.915-27.566-53.756-46.092l27.867 16.573 25.889 29.52z",
    fill: "#099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14C0C4",
    d: "M307.488 158.663l76.932 32.167 15.777 82.824-40.021-70.577-74.475-28.114z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootlab);
export default __webpack_public_path__ + "static/media/footlab.d85b67fde4bb58a307935a2525de3cac.svg";
export { ForwardRef as ReactComponent };